import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "The Lace Library",
    body: "Hundreds of trims line our shelves — chantilly, crochet, zari borders and hand-beaded pearls, cut to the metre for brides, tailors and dreamers.",
  },
  {
    n: "02",
    title: "The Tailor's Table",
    body: "Forged shears, spun-poly threads, zips in every length and buttons by the rainbow. Everything a working tailor reaches for, within arm's reach.",
  },
  {
    n: "03",
    title: "The Artist's Corner",
    body: "Camel watercolours, acrylics, brushes and sketchbooks — a quiet corner of the shop where N. Paravur's painters stock up.",
  },
  {
    n: "04",
    title: "The Maker's Shelf",
    body: "String-art kits, sequins, tassels and party garlands. Small boxes of possibility for school projects, gifts and rainy afternoons.",
  },
];

export const Manifesto = () => (
  <section
    id="story"
    data-testid="manifesto-section"
    className="py-28 md:py-40 bg-[#FBF9F6]"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid grid-cols-12 gap-6 mb-20 md:mb-28">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="col-span-12 md:col-span-3 font-accent text-xs tracking-[0.35em] uppercase text-[#C5A059]"
        >
          A Manifesto of Making
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="col-span-12 md:col-span-8 md:col-start-5 font-serif-d font-light text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-[#2D1B36]"
        >
          One small shop on Court Road,{" "}
          <span className="italic text-[#4A2B58]">
            a thousand ways to make something beautiful.
          </span>
        </motion.h2>
      </div>

      <div className="space-y-0">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.05 * i }}
            className="grid grid-cols-12 gap-6 items-baseline py-10 md:py-14 border-t border-[#E8E4DF] group"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span className="col-span-3 md:col-span-2 font-serif-d italic font-light text-6xl md:text-8xl text-outline group-hover:text-[#C5A059] transition-colors duration-500">
              {c.n}
            </span>
            <h3 className="col-span-9 md:col-span-4 font-serif-d font-normal text-2xl sm:text-3xl text-[#2D1B36]">
              {c.title}
            </h3>
            <p className="col-span-12 md:col-span-5 md:col-start-8 text-base leading-relaxed text-[#514357]">
              {c.body}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
